import { render, staticRenderFns } from "./lecture-list-item.vue?vue&type=template&id=1a497276&scoped=true"
import script from "./lecture-list-item.vue?vue&type=script&lang=js"
export * from "./lecture-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a497276",
  null
  
)

export default component.exports